import { defineComponent as _defineComponent } from 'vue'
import { isSmallScreenComposition } from '@/components/nav/mobileUtils'
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router/composables'
import Dashboard from '@/models/dashboard'
import { groupBy, orderBy } from 'lodash'
import VsText from '@/components/vision/VsText.vue'
import { useScreen } from '@/common/useScreen'


export default /*#__PURE__*/_defineComponent({
  __name: 'AnalyticsAside',
  props: {
    dashboards: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { dashboards: Dashboard[] }



const route = useRoute()
const { isMobileView } = useScreen()
const selectedDashboardId = computed(() => {
  if (route.name === 'new-metabase-dashboard') {
    return parseInt(route.params.id, 10)
  }
  return null
})
const selectedOwnerId = computed(
  () =>
    props.dashboards?.find((d) => d.id === selectedDashboardId.value)?.ownerId
)
const handleExpandToggled = (ownerId: string) => {
  const targetGroupIndex = availableRoutesGroupedByOwner.value.findIndex(
    (g) => g.ownerId === ownerId
  )

  availableRoutesGroupedByOwner.value[targetGroupIndex].isExpanded =
    !availableRoutesGroupedByOwner.value[targetGroupIndex].isExpanded
}

watch(
  () => route,
  () => {
    availableRoutesGroupedByOwner.value.forEach((group) => {
      group.isExpanded = false
    })
  }
)

const availableRoutesGroupedByOwner = ref<
  {
    ownerId: string
    ownerName: string
    routes: {
      id: number
      name: string
      metabaseDashboardId: number
      ownerId: string
      ownerName: string
      label: string
      to: string
    }[]
    isExpanded: boolean
  }[]
>([])

watch(
  () => props.dashboards,
  (newDashboards) => {
    let dashboardsWithRoutes = newDashboards.map((dashboard) => ({
      label: dashboard.name,
      to: `/analytics/dashboards/${dashboard.id}`,
      ...dashboard,
    }))
    dashboardsWithRoutes = orderBy(dashboardsWithRoutes, (d) =>
      d.label.toLowerCase()
    )
    const groupedRoutesMap = groupBy(dashboardsWithRoutes, (d) => d.ownerId)
    const groupedRoutesArray = Object.keys(groupedRoutesMap).map((ownerId) => {
      return {
        ownerId,
        ownerName: groupedRoutesMap[ownerId][0].ownerName,
        routes: groupedRoutesMap[ownerId],
        isExpanded: false,
      }
    })
    availableRoutesGroupedByOwner.value = orderBy(groupedRoutesArray, (g) =>
      g.ownerName.toLowerCase()
    )
  },
  { immediate: true }
)

return { __sfc: true,props, route, isMobileView, selectedDashboardId, selectedOwnerId, handleExpandToggled, availableRoutesGroupedByOwner, VsText }
}

})